<template>
  <div class="content" ref="contentRef">
    <!--翻页按钮-->
    <div
      class="previous-page page-button"
      :class="{ 'on-show': showPageHan }"
      @mouseover="showPageHan = !showPageHan"
      @click="$emit('onPreviousClick')"
      @mouseout="showPageHan = !showPageHan"
    >
      <div class="in"><LeftOutlined :style="{ color: '#fff' }" /></div>
    </div>
    <div
      class="next-page page-button"
      :class="{ 'on-show': showPageHanNext }"
      @mouseover="showPageHanNext = !showPageHanNext"
      @click="$emit('onNextClick')"
      @mouseout="showPageHanNext = !showPageHanNext"
    >
      <div class="in"><RightOutlined :style="{ color: '#fff' }" /></div>
    </div>
    <!--end 翻页按钮-->
    <div class="group group1">
      <div class="rotate9"><span>Andon Event</span></div>
      <div
        class="row"
        v-for="items in andonTypeItems"
        :key="items.andonCshowName"
      >
        <div class="col title">
          {{ items.andonCshowName }}
        </div>
        <div
          class="col"
          v-for="(item, idx) in items.pageAndonColumns"
          :key="items.andonCshowName + idx"
          @click="$emit('colClick', item)"
          :class="showColor(item)"
        >
          <span class="ic">
            <i
              class="iconfont"
              :class="iconType(item.status, items.andonCshowName)"
            ></i>
          </span>
          <span class="txt">{{ item.count == 0 ? '-' : item.count }}</span>
        </div>
        <div class="col flex-w2" @click="$emit('showAndonSummary', items)">
          <column-progress-bar
            :summary-type="summaryType"
            :number="items.summary * 1"
            width="100"
          ></column-progress-bar>
        </div>
      </div>
    </div>
    <div class="divider"></div>
    <div class="group group2">
      <div class="rotate9">
        <span>Status Alert</span>
      </div>
      <div class="row kit" v-if="kitStatusItems.length > 0">
        <div class="col title">Kit Status</div>
        <ul class="col" v-for="(items, index) in kitStatusItems" :key="index">
          <li
            @click="$emit('onKitStatusShow', item)"
            v-for="(item, idx) in items.pageKitStatusColumns"
            :key="index + '-' + idx"
          >
            <b class="num">
              <span v-if="item.cfgPageIlPace.paceName != 0">+</span>
              {{ item.cfgPageIlPace.paceName }}
            </b>
            <div class="kit-scroll-box">
              <vue-seamless-scroll
                :data="item.regionCodes"
                :class-option="classOption(item.cfgPageIlPace.scrollInterval)"
                class="scroll-box"
                v-if="item.regionCodes.length"
              >
                <span
                  class="st red"
                  v-for="i in item.regionCodes"
                  :key="i"
                  :class="{
                    red: item.status == 'RED',
                    green: item.status == 'GREEN',
                    grey: item.status == 'GREY',
                    orange: item.status == 'YELLOW',
                  }"
                >
                  <i :style="setFontSize(i)">{{ i }}</i>
                </span>
              </vue-seamless-scroll>
              <span
                class="st"
                v-if="item.regionCodes.length === 0"
                :class="{
                  red: item.status == 'RED',
                  green: item.status == 'GREEN',
                  grey: item.status == 'GREY',
                  orange: item.status == 'YELLOW',
                }"
              >
                <i>&nbsp;</i>
              </span>
            </div>
          </li>
        </ul>
        <div class="col flex-w2"></div>
      </div>
      <div class="row" v-if="fifoStockItems.length > 0">
        <div class="col title">FIFO Stock</div>
        <div class="col" v-for="(items, index) in fifoStockItems" :key="index">
          <text-scroll
            :wait-time="fifoRefreshInterval"
            :data="items.matFifoCombinedBeans"
            @click="$emit('onFifoStockShow', items)"
          ></text-scroll>
        </div>
        <div class="col flex-w2"></div>
      </div>
    </div>
  </div>
</template>
<script>
  // import { throttle } from '@/utils'
  import ColumnProgressBar from './column-progress-bar'
  import textScroll from './text-scroll.vue'
  import { LeftOutlined, RightOutlined } from '@ant-design/icons-vue'
  import vueSeamlessScroll from 'vue-seamless-scroll/src'
  export default {
    components: {
      ColumnProgressBar,
      textScroll,
      LeftOutlined,
      RightOutlined,
      vueSeamlessScroll,
    },
    props: {
      andonTypeItems: {
        type: Array,
        default() {
          return []
        },
      },
      kitStatusItems: {
        type: Array,
        default() {
          return []
        },
      },
      fifoStockItems: {
        type: Array,
        default() {
          return []
        },
      },
      summaryType: {
        type: String,
        default: '',
      },
      fifoRefreshInterval: {
        type: Number,
        default: 30000,
      },
    },
    data() {
      return {
        showPageHan: false,
        showPageHanNext: false,
        boxHeight: 50,
      }
    },

    watch: {},
    mounted() {
      // window.addEventListener('resize', throttle(this.init, 500))

      const _this = this
      window.addEventListener('resize', () => {
        _this.boxHeight = (window.innerWidth * 3.472) / 100
      })
    },
    methods: {
      classOption(waitTime) {
        return {
          singleHeight: this.boxHeight,
          waitTime,
          limitMoveNum: 2,
          direction: 1,
        }
      },
      toPrefix(input) {
        var a = input.split('_')
        if (a.length == 1) {
          return a[0]
        } else {
          return a[1]
        }
      },
      setFontSize(str) {
        if (str) {
          return { fontSize: (20 - str.length * 2) / 15 + 'rem' }
        }
      },
      showSummary(item) {
        this.$emit('showSummary', item)
      },

      showColor(item) {
        if (item.status * 1 == 1 || item.status * 1 == 2) {
          return 'danger'
        } else if (item.status * 1 == 3) {
          return 'green'
        }
        return
      },

      iconType(status, name) {
        var setIcon = function (a, b) {
          if (status * 1 === 1) {
            return a
          } else {
            return b
          }
        }
        switch (name) {
          case 'Safety':
            return setIcon('icon-add', 'icon-add-o')

          case 'Quality':
            return setIcon('icon-ling', 'icon-ling-o')

          case 'Material':
            return setIcon('icon-ladder', 'icon-ladder-o')

          case 'Machine':
            return setIcon('icon-tool', 'icon-tool-o')

          case 'Others':
            return setIcon('icon-nabla', 'icon-nabla-o')
          case 'Miss_Pull':
            return setIcon('icon-k', 'icon-k-o')
          default:
            return setIcon('icon-k', 'icon-k-o')
        }
      },
    },
  }
</script>

<style lang="less" scoped>
  @import '~@/styles/variables.less';
  .content {
    box-shadow: 2px 0 2px @black1;
    background-color: #fefefe;
    position: relative;
    height: calc(100vh - 100px - 32px - 10px);
    overflow: hidden;
    display: flex;
    flex-direction: column;
    .group1 {
      height: calc(100% - 181px);
    }
    .group2 {
      height: 180px;
    }
    .group {
      position: relative;
      padding-left: 50px;
      background-color: #f4f5f7;
      min-height: 180px;
      > .row:last-child > .col {
        border-bottom: none;
      }
    }
    .group {
      min-height: initial;
      display: flex;
      flex-direction: column;
      .row {
        display: flex;
        flex: 1;
        align-items: center;
        justify-content: center;
        ul.col {
          list-style: none;
          padding: 0;
          margin: 0;
        }
        .col {
          border-right-color: #e9e9ef;
          font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
          color: @gray8;
          display: flex;
          align-items: center;
          justify-content: center;
          height: 100%;

          .txt {
            min-width: 40px;
            font-size: 18px;
          }
          .ic .iconfont {
            font-size: 32px;
          }
        }
        .col.flex-w2 {
          justify-content: start;
        }
      }
      .row dl.col {
        margin: 0;
        display: table-row;
      }
      .row .col.title {
        border-right: 1px solid #6c7277;
      }
    }

    .row {
      padding: 0;
      margin: 0;
      overflow: hidden;
      border-left: 1px solid @black1;
      background: #fefefe;
      display: flex;
      width: 100%;
      .col {
        height: 56.4px;
        line-height: 56.4px;
        border-right: 1px solid #f7f7f8;
        border-bottom: 1px dashed #cdd0d2;
        text-align: center;
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        &:nth-last-child(2) {
          border-color: @lineBlue;
        }

        &.flex-w2 {
          flex: 0 0 200px;
          background: #f4f5f7;
          border: none;
          text-align: left;
          padding-left: 20px;
          &.-px {
            box-shadow: 3px 0 3px -1px @black1 inset;
          }
        }
        &.title {
          box-shadow: 2px 0 2px @black1;
          border-right: 1px solid @lineBlue;
          color: #636b80;
          flex: 0 0 100px;
          font-size: 16px;
        }
        &:last-child {
          border-right: none;
        }
        &.danger {
          .ic,
          .txt {
            color: @danger;
          }
        }

        &.green {
          .ic,
          .txt {
            color: @green;
          }
        }
        .ic,
        .txt {
          display: inline-block;
          vertical-align: middle;
          min-width: 40px;
          font-size: 24px;
          color: #d8e0e3;
          font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
        }
        .txt {
          font-size: 18px;
          min-width: 80px;
        }
        .ic {
          .iconfont {
            font-size: 24px;
          }
        }
      }
    }
  }
  .rotate9 {
    display: block;
    width: 50px;
    position: absolute;
    height: 100%;
    left: 0;
    top: 0;
    bottom: 0;
    > span {
      display: block;
      width: 100%;
      text-align: center;
      font-weight: normal;
      font-size: 20px;
      color: #636b80;
      writing-mode: vertical-rl;
      height: 100%;
      line-height: 50px;
      transform: rotate(180deg);
    }
  }
  .divider {
    height: 1px;
    background: @lineBlue;
  }
  .previous-page,
  .next-page {
    position: absolute;
    font-size: 40px;
    top: 50%;
    margin-top: -150px;
    left: 0;
    height: 300px;
    min-height: 30px;
    min-width: 30px;
    line-height: 24px;
    width: 50px;
    padding: 0;
    background: transparent;
    z-index: 1000;
  }

  .previous-page .in,
  .next-page .in {
    position: absolute;
    top: 50%;
    margin-top: -24px;
    background: @subMaster;
    border: 1px solid @subMaster;
    width: 48px;
    height: 48px;
    text-align: center;
    border-radius: 50%;
    padding: 0;
    transform: translateX(-70px);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s;
    i.icon {
      vertical-align: middle;
      color: @white;
    }
  }
  .on-show.previous-page,
  .on-show.next-page {
    .in {
      transform: translateX(0);
    }
  }
  .previous-page.activated,
  .next-page.activated {
    border: none;
    background-color: transparent;
  }
  .next-page {
    right: 0;
    left: initial;
    .in {
      transform: translateX(70px);
    }
  }
  .kit {
    height: 80px;
    .col {
      display: flex;
      height: auto;
      align-items: center;
      justify-content: center;
      li {
        flex: 1;
        height: 100%;
        display: flex;
        flex-direction: column;
        width: 33.33333%;
        &:last-child {
          border: none;
          b,
          .st {
            border-right: none;
          }
        }
        .kit-scroll-box {
          overflow: hidden;
          height: 100%;
          > div,
          .st {
            height: 100%;
          }
        }
        b {
          display: block;
          height: 40px;
          line-height: 40px;
          text-align: center;
          background: #f3f6ff;
          border-bottom: 1px solid #d7dbe6;
          border-right: 1px solid #d7dbe6;
          font-weight: normal;
          font-size: 16px;
        }
        .st {
          border-right: 1px solid #f7f7f8;
          display: flex;
          min-height: 50px;
          padding: 5px;
          align-items: center;
          justify-content: center;
          flex: 1;
          i {
            font-style: normal;
            font-size: 16px;
            display: flex;
            height: auto;
            //border-radius: 5px;
            line-height: 1;
            width: auto;
            padding: 5px;
            min-height: 40px;
            min-width: 40px;
            align-items: center;
            justify-content: center;
          }
        }
        .red i {
          background: @danger;
          color: #fff;
        }
        .green i {
          background: @green;
          color: #fff;
        }
        .orange i {
          background: @warning;
          color: #fff;
        }
        .grey i {
          background: @gray-f;
        }
      }
    }
  }
  .kit + .row {
    height: 100px;
  }
</style>
